<!-- <div>
    <header>
      <h1>My Angular App</h1>

      <div>
        <h2>Authentication</h2>
        <button (click)="login()" *ngIf="!isLoggedIn">Login</button>
        <button (click)="logout()" *ngIf="isLoggedIn">Logout</button>
        <div *ngIf="isLoggedIn">
          <p>User: {{ userName }}</p>
        </div>
      </div>

      <p>
        <button (click)="loadIntents()">Load Intent</button>
      </p>


    </header>
    <main>
      <router-outlet></router-outlet>
    </main>
  </div>




 -->

<!-- Login overlay (shown when not authenticated) -->
<div *ngIf="!isLoggedIn" class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-75" style="z-index: 9999;">
  <div class="card p-4 shadow-lg">
    <h3 class="text-center mb-4">Welcome to Admin Panel</h3>
    <p class="text-center mb-4">Please sign in to continue</p>
    <button class="btn btn-primary btn-lg" (click)="login()">
      <i class="bi bi-microsoft me-2"></i>
      Sign in with Microsoft
    </button>
  </div>
</div>


<!-- Pure Bootstrap Admin Layout -->
<div class="container-fluid">

  <div class="row">
        
    <!-- Sidebar -->
    <div class="col-md-3 col-lg-2 p-0 bg-dark min-vh-100 position-md-fixed">
      <app-sidebar></app-sidebar>
    </div>

    <!-- Main content area -->
    <div class="col-md-9 col-lg-10 ms-md-auto p-0">
      <!-- Top navigation bar -->
      <nav class="navbar navbar-expand-lg navbar-light bg-light border-bottom px-3 shadow-sm">
        
        <h4 class="text-primary">SMART Engage Hub - Admin</h4>

        <!-- Hamburger menu for mobile -->
        <button class="navbar-toggler d-md-none" type="button" data-bs-toggle="collapse" data-bs-target="#sidebarMenu">
          <span class="navbar-toggler-icon"></span>
        </button>

        <!-- Search form -->
        <form class="d-flex ms-auto me-3">
          <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
          <button class="btn btn-outline-primary" type="submit">Search</button>
        </form>

       <!-- User dropdown -->
       <div class="dropdown" *ngIf="isLoggedIn">
        <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          <span class="border rounded-circle p-2 me-2 d-inline-flex align-items-center justify-content-center" style="width: 32px; height: 32px;">
            <i class="bi bi-person-fill"></i>
          </span>
          <span>{{userName || 'User'}}</span>
        </a>
        <ul class="dropdown-menu dropdown-menu-end shadow-sm" aria-labelledby="userDropdown">
          <li><a class="dropdown-item" href="#" (click)="logout()"><i class="bi bi-box-arrow-right me-2"></i>Sign out</a></li>
        </ul>
      </div>

      </nav>


      <!-- Main content area with router-outlet -->
      <main class="p-4">
        <router-outlet></router-outlet>
      </main>



      <!-- Footer -->
      <footer class="bg-light p-3 border-top text-center">
        <p class="mb-0">&copy; 2025 ICS.AI. All rights reserved.</p>
      </footer>
    </div>
  </div>
</div>